import { FilterType } from "@/lib/filters";
import MonthYearNavigation from "@/components/MonthYearNavigation";
import { YM_DATE_FORMAT } from "@/constants";
import { DateTime } from "luxon";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDataTableSettings } from "../hooks/useDataTableSettings";
import { useFilterState } from "../hooks/useFilterState";
import { monthYearFilterToDate } from "../utils/monthYearFilterToDate";

export interface MonthYearTableFilterProps {
  columnId: string;
  disabled?: boolean;
  className?: string;
  popoverClassName?: string;
}

export function MonthYearTableFilter({
  columnId,
  disabled,
  className,
  popoverClassName,
}: MonthYearTableFilterProps) {
  const { t } = useTranslation();
  const { options } = useDataTableSettings();
  const { columnFilterValue } = useFilterState({
    columnId,
    defaultFilterType: FilterType.EqualsString,
  });
  const value = monthYearFilterToDate(columnFilterValue);

  const onMonthChange = useCallback(
    (date: Date) =>
      options.setFilterValue(columnId, {
        filter: FilterType.EqualsString,
        value: DateTime.fromJSDate(date).toFormat(YM_DATE_FORMAT),
      }),
    [options, columnId],
  );

  return (
    <MonthYearNavigation
      value={value}
      onMonthChange={onMonthChange}
      className={className}
      popoverClassName={popoverClassName}
      disabled={disabled}
      emptyStateLabel={t("monthYearFilter.noFilter")}
    />
  );
}
